module.exports = __webpack_public_path__ + "media/images/review/star_1-f222253c92d16d8efeb78405063825d5.svg";